import { Style } from "@portal/lib/style/style";
import { Tags } from "./AntTag";

export const StyledTag = Style(Tags, {
  "&.ant-tag": {
    border: 0,
  },

  variants: {
    design: {
      "no-bg": {
        backgroundColor: "transparent",
      },
    },
  },
});
